var _defs, _path, _path2, _path3, _rect, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdukiLogo100302(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 233.75 79.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#26BFBF;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281,151c7.83,0,13.52-7.06,13.52-17.25V105.83H282v27.82c0,6.22-3.83,10.23-9.26,10.23a8.92,8.92,0,0,1-2.91-.48C272.28,148,276.38,151,281,151Z",
    transform: "translate(-139.96 -84.05)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.49,133.71V105.83H250.94v27.82a21.82,21.82,0,0,0,27.92,21.13C270.21,153.48,263.49,144.54,263.49,133.71Z",
    transform: "translate(-139.96 -84.05)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.37,85.14a7.49,7.49,0,0,1,7.49,7.5,7.45,7.45,0,0,1-14.89,0A7.48,7.48,0,0,1,359.37,85.14Z",
    transform: "translate(-139.96 -84.05)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 213.18,
    y: 21.79,
    width: 12.56,
    height: 38.03
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.37,154.64h12V84.05H230.8v26.27a20.56,20.56,0,0,0-14.46-5.71c-12.75,0-23.3,11-23.3,25.59s10.55,25.49,23.3,25.49a20.51,20.51,0,0,0,15-6.28Zm-13.13-10.76c-6.94,0-12.55-5.79-12.55-13.59,0-8,5.61-14.08,12.55-14.08s12.56,6.28,12.56,14.08C230.8,137.9,225.19,143.88,218.24,143.88Z",
    transform: "translate(-139.96 -84.05)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.69,147.75a19.43,19.43,0,0,1-10.9,3.32c-7.1,0-11.28-2-15.41-7.54l-12.11-17,19.8-20.71H330.76l-16.07,17.78V84.05H302.14v70.59h12.55v-13.9l4.75-5,10.77,15.11.08.11c6.54,8.74,14.4,12.63,25.5,12.63a32,32,0,0,0,17.93-5.47Z",
    transform: "translate(-139.96 -84.05)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.49,142.84c-4.91,3.35-10.32,6.52-17.64,5.95a17,17,0,0,1-14.69-10.87l.41.08c11.79,1.84,22.39.1,28.46-4.73a14.58,14.58,0,0,0,5.67-11,16,16,0,0,0-2.26-9l-.57-.93-.16,1.08a13.19,13.19,0,0,1-5.7,9.19c-7.55,5.25-20.27,4.51-26.33,3.33a14.23,14.23,0,0,1,14.83-9.69,20.27,20.27,0,0,1,8.92,3.11l.23.13.15-.09a7,7,0,0,0,3.39-5.67c.26-4.43-5.56-8.45-12.67-9a25.06,25.06,0,0,0-19.1,6.6A26.16,26.16,0,0,0,140,129s-.06,1.37,0,2.34c.23,15.41,11.59,28.11,26.95,29.31,1,.08,1.92.11,2.85.11,10.52-.07,18.09-5.11,22.4-8.07Z",
    transform: "translate(-139.96 -84.05)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdukiLogo100302);
export default __webpack_public_path__ + "static/media/eduki_logo_1003_02.8b7a0b4700a4d6113b26dd35867bfe96.svg";
export { ForwardRef as ReactComponent };